import { Lounge } from '@utils/types';
import type { PartnerLocationFilters } from '@utils/partnerSession';
import { axiosInstance } from '.';

export interface LoungesByCityResult {
  lounges: Lounge[];
  filtersApplied: boolean;
}

export const getCitiesApi = async (): Promise<string[]> => {
  const { data: res } = await axiosInstance.get('/v1/lounge/get-cities');

  return res.data.cities;
};

export const getLoungesApi = async (
  city: string,
  filters?: PartnerLocationFilters,
): Promise<LoungesByCityResult> => {
  const { data: res } = await axiosInstance.get(
    `/v1/lounge/get-city-lounges/${city}`,
    {
      params: {
        ...(filters?.terminalName
          ? { terminal_name: filters.terminalName }
          : {}),
        ...(filters?.terminalType
          ? { terminal_type: filters.terminalType }
          : {}),
        ...(filters?.loungeId ? { lounge_id: filters.loungeId } : {}),
      },
    },
  );

  return {
    lounges: res.data.lounges ?? [],
    filtersApplied: Boolean(res.data.filters_applied),
  };
};
